import { render, staticRenderFns } from "./TgDownloadPage.vue?vue&type=template&id=9fb8a8c0&"
import script from "./TgDownloadPage.vue?vue&type=script&lang=js&"
export * from "./TgDownloadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports